export default "__VITE_ASSET__CWERHWtq__"